import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import type { AlertColor } from '@mui/material/Alert';

import { ActionableMessages } from './ActionableMessages';
import type { ActionableMessage } from './ActionableMessages';

interface Props {
  readonly items: readonly ActionableMessage[];
  readonly severity: AlertColor;
  readonly title: string;
}

// The messages of one level, listed in a single alert with their actions under the list:
// nothing without any.
export const ActionableAlert = ({ items, severity, title }: Readonly<Props>) =>
  items.length ? (
    <Alert severity={severity}>
      <AlertTitle>{title}</AlertTitle>
      <ActionableMessages items={items} />
    </Alert>
  ) : null;
